import { render } from "./Total.vue?vue&type=template&id=48df044c&scoped=true"
import script from "./Total.vue?vue&type=script&lang=js"
export * from "./Total.vue?vue&type=script&lang=js"

import "./Total.vue?vue&type=style&index=0&id=48df044c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48df044c"]])

export default __exports__